import variables from '../../variables';
import {$dom} from '../../helpers/dom';
import is from 'is_js';
import gsap from 'gsap';
import {clearNum} from '../helpers';

const {
	exist,
	getAll,
	each,
	get,
	attr
} = $dom;

export default function cardFees(
	feesHolderSelector = '.js-card-project-fees',
	progressSelector = '.js-card-project-fees-progress',
	barToSelector = '.js-card-project-fees-bar-to',
	totalAmountAttr = 'data-total-amount',
	currentAmountAttr = 'data-current-amount'
) {

	if (exist(feesHolderSelector)) {

		let holders;
		const
			calculatePercent = (t, c) => {
				return parseFloat((c * 100 / t).toFixed(2))
			}
		;

		const
			init = () => {
				holders = getAll(feesHolderSelector);

				each(holders, feesHolder => {


						const
							totalAmount = clearNum(attr(feesHolder, totalAmountAttr)),
							currentAmount = clearNum(attr(feesHolder, currentAmountAttr))
						;

						if (
							(is.not.null(totalAmount) && is.not.null(currentAmount))
							&&
							(is.not.nan(totalAmount) && is.not.nan(currentAmount))
						) {

							if (exist(progressSelector, feesHolder)) {
								const
									progress = get(progressSelector, feesHolder),
									barTo = get(barToSelector, feesHolder),
									barToWidth = barTo.offsetWidth,
									percent = calculatePercent(totalAmount, currentAmount),
									progressInPx = feesHolder.offsetWidth * percent / 100,
									barToPos = feesHolder.offsetWidth - progressInPx
								;


								gsap.set(progress, {width: progressInPx});

								gsap.set(barTo, {
									right: barToPos >= feesHolder.offsetWidth ? barToPos - barToWidth : barToPos
								});

							}
						}

				});

			},
			destroy = () => {
				gsap.set(progressSelector, {clearProps: 'width'});
				gsap.set(barToSelector, {clearProps: 'right'});
			},
			update = () => {
				destroy();
				init();
			}
		;

		return {init, destroy, update}
	}

	return null;
}
